import React, { useState, useEffect } from 'react';
import { TextField, Button, Stack, Typography } from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

const ApplicationsForm = ({ onSubmit, initialData }) => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { app, getApp, postApplication, putApplication } = useAppContext();
  const isEditMode = Boolean(id);
  const [form, setForm] = useState(initialData || {
    id: '',
    name: '',
    code: '',
    description: '',
    OnePlatformMetric_id: '',
  });

  useEffect(() => {
    if (isEditMode) {
      getApp(id);
    }
  }, [id, isEditMode]);

  useEffect(() => {
    if (isEditMode && app && Object.keys(app).length > 0) {
      setForm({
        id: app.id || app.application_id || id || '',
        name: app.name || app.application_name || '',
        code:
          app.UanatacaBillingCode ||
          app.uanataca_billing_code ||
          app.code ||
          app.application_code ||
          '',
        description: app.description || app.application_description || '',
        OnePlatformMetric_id:
          app.OnePlatformMetric_id ||
          app.onePlatformMetric_id ||
          app.one_platform_metric_id ||
          '',
      });
    }
  }, [app, id, isEditMode]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isEditMode) {
        await putApplication(form.id, {
          name: form.name,
          code: form.code,
          description: form.description,
          OnePlatformMetric_id: form.OnePlatformMetric_id,
        });
      } else {
        await postApplication({
          id: form.id,
          name: form.name,
          code: form.code,
          description: form.description,
          OnePlatformMetric_id: form.OnePlatformMetric_id,
        });
      }

      if (onSubmit) {
        onSubmit(form);
      }

      navigate('/applications');
    } catch (err) {
      console.error('Error saving application:', err);
      alert('Error saving application');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h6">Application Form</Typography>
      <Stack spacing={2} direction="column" sx={{ my: 2 }}>
        <TextField
          label="ID"
          name="id"
          value={form.id}
          onChange={handleChange}
          fullWidth
          disabled={isEditMode}
        />
        <TextField
          label="Name"
          name="name"
          value={form.name}
          onChange={handleChange}
          fullWidth
          disabled={false}
        />
        <TextField
          label="Code"
          name="code"
          value={form.code}
          onChange={handleChange}
          fullWidth
          disabled={false}
        />
        <TextField
          label="Description"
          name="description"
          value={form.description}
          onChange={handleChange}
          fullWidth
          disabled={false}
        />
        <TextField
          label="One Platform Metric ID"
          name="OnePlatformMetric_id"
          value={form.OnePlatformMetric_id}
          onChange={handleChange}
          fullWidth
          disabled={false}
        />
        <Button variant="contained" type="submit" fullWidth>
          {isEditMode ? 'Update Application' : 'Create Application'}
        </Button>
      </Stack>
    </form>
  );
};

export default ApplicationsForm;
